export const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL || 'https://cloud.ru';

export const DEFAULT_VALUE = {
  title: 'Облако Cloud.ru — облачный провайдер IaaS/PaaS и ML сервисов',
  description:
    'Cloud.ru (ООО «Облачные технологии») – облачный провайдер IaaS/PaaS и Machine Learning сервисов. Вычислительные ресурсы, хранение данных в облаке, мониторинг и управление, сервисы для Big Data. Тел: +7 495 260-10-82',
  image: '/favicons/logo-180.png',
};
